import React, { useState } from "react";
import { Route, Switch, useLocation, RouteComponentProps, useHistory } from "react-router";
import { Sidebar } from "cm-layout";
import { User } from "oidc-client";
import "cm-layout/lib/cm-layout.css";
import { SidebarOptionIcon } from "../../Layout/Components/Sidebar/SidebarOptionIcon";
import { SidebarAppLinks } from "../../Layout/Components/Sidebar/SidebarAppLinks";
import { SidebarType } from "../Constants/sideBarType";
import { appPaths } from "../../Common";
import { useSidebarContents } from "../Hooks/useSidebarContents";
import { useActiveContext } from "../Hooks/useActiveContext";
import AppSelectorDropdown from "../../Layout/Components/ContextSelectorDropdown";
import { Company } from "../../Company/Models/Company";

type SidebarProps = {
  user?: User;
  company?: Company;
};

export const FeedbackSidebar = (props: SidebarProps) => {
  const [sideBarCollapsed, setSideBarCollapsed] = useState(false);
  const [appMenuOpen, setAppMenuOpen] = useState(false);
  const { activeApp, activeTopic } = useActiveContext();

  return (
    <Sidebar collapsed={sideBarCollapsed} onToggle={() => setSideBarCollapsed(!sideBarCollapsed)}>
      <Switch>
        <Route path={appPaths.topic.specificRoot}>
          <SidebarItems {...props} type={SidebarType.Topic} />
        </Route>
        <Route path={appPaths.tags.root}>
          <SidebarItems {...props} type={SidebarType.Home} />
        </Route>
        <Route path={appPaths.topic.root}>
          <SidebarItems {...props} type={SidebarType.Home} />
        </Route>
        <Route path={appPaths.overview.root}>
          <SidebarItems {...props} type={SidebarType.Home} />
        </Route>
        <Route path={appPaths.generalError}>
          <SidebarItems {...props} type={SidebarType.Home} />
        </Route>
        <Route path={appPaths.notFound}>
          <SidebarItems {...props} type={SidebarType.Home} />
        </Route>
        <Route path={appPaths.auth.root}>
          <SidebarItems {...props} type={SidebarType.Home} />
        </Route>
        <Route path={appPaths.company.root}>
          <SidebarItems {...props} type={SidebarType.Home} />
        </Route>
        <Route path={appPaths.user.root}>
          <SidebarItems {...props} type={SidebarType.Home} />
        </Route>
        <Route path={appPaths.workflows.root}>
          <SidebarItems {...props} type={SidebarType.Home} />
        </Route>
        <Route path={appPaths.app.root}>
          <SidebarItems {...props} type={SidebarType.App} />
        </Route>

        <Route path={appPaths.root}>
          <SidebarItems {...props} type={SidebarType.Home} />
        </Route>
      </Switch>
      <Sidebar.AppMenu isOpen={appMenuOpen} onSwitchAppClick={() => setAppMenuOpen(!appMenuOpen)}>
        <SidebarAppLinks />
      </Sidebar.AppMenu>
    </Sidebar>
  );
};

const mapToLink = (l: any, pathName: string, redirect: (path: string) => void) => {
  if (l.isSpecial) {
    if (l.type === "divider") {
      return <Sidebar.Divider />;
    }
    if (l.type === "contextSelector") {
      return <AppSelectorDropdown />;
    }
    // if (l.type === "projectSelector") {
    //   return <ProjectSelector />;
    // }
    // unexpected special type here
    return null;
  }

  return (
    <Sidebar.Item
      key={l.name}
      name={l.name}
      icon={<SidebarOptionIcon icon={l.icon} />}
      href={l.path}
      active={pathName === l.path}
      // eslint-disable-next-line react/no-children-prop
      children={
        l.isGroup && !!l.children.length
          ? l.children.map((lc: any) => mapToLink(lc, pathName, redirect))
          : null
      }
      onHoverClick={l.createPath ? () => redirect(l.createPath) : undefined}
    />
  );
};

type Props = {
  links: any[];
};

const NavLinks: any = (props: Props & RouteComponentProps) => {
  const { pathname } = useLocation();
  const history = useHistory();

  const redirect = (path: string) => {
    if (!!path && history.location.pathname !== path) {
      history.push(path);
    }
  };

  return props.links.map(l => mapToLink(l, pathname, redirect));
};

type SidebarItemsProps = {
  type: SidebarType;
  user?: User;
  company?: Company;
};

const SidebarItems: React.FC<SidebarItemsProps> = (props: SidebarItemsProps) => {
  const sidebarContents = useSidebarContents(props.type, props.user, props.company);
  return (
    <>
      <NavLinks links={sidebarContents} />
    </>
  );
};
